import React, { useState } from 'react';
import BaseForm from 'components/Inputs/Forms/BaseForm';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  InputLabel,
  TextField,
  Select,
  MenuItem,
} from '@mui/material';

const styles = require('./styles.pcss');

export interface CredentialsFormProps {
  onSubmit: ({username, password, type}: {username: string, password: string, type: string}) => void;
  isLoading?: boolean;
  handleClose: Function;
}

const CredentialsForm: React.FC<CredentialsFormProps> = ({
  onSubmit,
  isLoading,
  handleClose,
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [type, setType] = useState('csvOrganizationSync')
  const handleSubmit = () => {
    if (username.trim() && password.trim() && type) {
      onSubmit({username: username.trim(), password: password.trim(), type});
    }
  };

  return (
    <>
      <DialogContent className={styles.formContainer}>
        <DialogContentText>
          Fill out the email for the org admin below.
        </DialogContentText>
        <TextField
          required
          margin="dense"
          id="email"
          name="email"
          label="Email Address"
          type="email"
          fullWidth
          onChange={(e) => setUsername(e.target?.value)}
          value={username}
        />
        <TextField
          required
          margin="dense"
          id="password"
          name="password"
          label="Password"
          type="password"
          fullWidth
          onChange={(e) => setPassword(e.target?.value)}
          value={password}
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            labelId="type-label"
            value={type}
            onChange={(e) => setType(e.target?.value)}
          >
            <MenuItem value="csvOrganizationSync">csvOrganizationSync</MenuItem>
            <MenuItem value="csvDepartmentsSync">csvDepartmentsSync</MenuItem>
            <MenuItem value="expenseCustomFieldSync">expenseCustomFieldSync</MenuItem>
            <MenuItem value="excelDirp3Sync">excelDirp3Sync</MenuItem>
            <MenuItem value="expenseCategorySync">expenseCategorySync</MenuItem>
            <MenuItem value="travelCustomFieldSync">travelCustomFieldSync</MenuItem>
            <MenuItem value="mirFileSync">mirFileSync</MenuItem>
            <MenuItem value="corporateCardSync">corporateCardSync</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => handleSubmit()}
          disabled={isLoading}
        >
          Add Integration
        </Button>
      </DialogActions>
    </>
  );
};

export default CredentialsForm;
